/*
 * File: /src/services/customFieldServices.js
 * Created Date: Thursday May 6th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Thursday, 6th May 2021 9:21:48 am
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

import { authedAxios } from '../shared/axiosWrapper';
import { AD_BASE_CUSTOM_FIELDS_PATH } from '../constants';

export default {
  fetchCustomFields() {
    return authedAxios.get(AD_BASE_CUSTOM_FIELDS_PATH);
  },
  fetchCustomFieldById(id) {
    return authedAxios.get(AD_BASE_CUSTOM_FIELDS_PATH + id);
  },
  addCustomField(body) {
    return authedAxios.post(AD_BASE_CUSTOM_FIELDS_PATH, body);
  },
  editCustomField(id, body) {
    return authedAxios.put(AD_BASE_CUSTOM_FIELDS_PATH + id, body);
  },
  deleteCustomField(id) {
    return authedAxios.delete(AD_BASE_CUSTOM_FIELDS_PATH + id);
  },

  // Field Value endpoints
  fetchCustomFieldValues(fieldId) {
    return authedAxios.get(`${AD_BASE_CUSTOM_FIELDS_PATH + fieldId}/values`);
  },
  addCustomFieldValue(fieldId, fieldValue) {
    return authedAxios.post(
      `${AD_BASE_CUSTOM_FIELDS_PATH + fieldId}/values`,
      fieldValue
    );
  },
  editCustomFieldValue(fieldId, id, fieldValue) {
    return authedAxios.put(
      `${AD_BASE_CUSTOM_FIELDS_PATH + fieldId}/values/${id}`,
      fieldValue
    );
  },
  deleteCustomFieldValue(fieldId, id) {
    return authedAxios.delete(
      `${AD_BASE_CUSTOM_FIELDS_PATH + fieldId}/values/${id}`
    );
  },
};
